import Icon from '@ant-design/icons';
import type { ModalProps } from 'antd';
import { Modal } from 'antd';
import classNames from 'classnames';

import smallSvg from '@/components/Icon/svgs/arrows-pointing-in.svg';
import bigSvg from '@/components/Icon/svgs/arrows-pointing-out.svg';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';

import ModalTitle from '../modal-title';
import styles from './index.less';

export enum SizeType {
  normal = 'normal',
  large = 'large',
  textNormal = 'textNormal',
  extraLarge = 'extraLarge'
}

export interface MindverseModalProps extends ModalProps {
  className?: string;
  size?: SizeType;
  title?: React.ReactNode;
  icon?: string;
  children?: React.ReactNode;
  width?: number;
  large?: boolean;
  onClickLarge?: () => void;
  onClickSmall?: () => void;
}

export default function MindverseModal(props: MindverseModalProps): JSX.Element {
  const {
    className,
    size,
    title,
    icon,
    children,
    footer,
    width: _width,
    large = false,
    onClickLarge,
    onClickSmall,
    ...otherModalProps
  } = props;

  let width = _width || 1000;
  const containerClass =
    footer === null
      ? 'nullFooter'
      : Array.isArray(footer) && footer.length === 0
        ? 'emptyFooter'
        : '';
  const largeClass = size == SizeType.large ? 'large' : '';
  const extraLargeClass = size == SizeType.extraLarge ? 'extraLarge' : '';
  const textNormal = size == SizeType.textNormal ? 'textNormal' : '';
  const [layoutSize] = useStorage('layoutSize');

  switch (size) {
    case SizeType.normal:
      width = 580;

      break;
    case SizeType.large:
      width = 900;

      break;
    case SizeType.textNormal:
      width = 580;

      break;
  }

  return (
    <Modal
      centered
      className={classNames(styles.modal, {
        [styles.isTextModal]: size == SizeType.extraLarge || size == SizeType.textNormal
      })}
      footer={footer}
      rootClassName={styles.root}
      width={width}
      {...otherModalProps}
    >
      {typeof title === 'string' ? <ModalTitle icon={icon} title={title} /> : title}
      <div
        className={classNames(
          styles.bodyContainer,
          styles[containerClass],
          styles[largeClass],
          styles[extraLargeClass],
          styles[textNormal],
          className,
          'transition-all',
          size == SizeType.extraLarge || size == SizeType.textNormal ? 'rounded-bl-[20px]' : ''
        )}
        style={{ paddingTop: typeof title === 'string' ? '4px' : '16px' }}
      >
        {children}
      </div>
      {layoutSize === LAYOUT_SIZE.SMALL ? null : (
        <>
          {large && size != SizeType.extraLarge ? (
            <div
              className="absolute cursor-pointer flex items-center justify-center ltr:right-[12px] rtl:left-[12px] top-[8px] text-[20px] text-[#00000072] hover:text-[#160a0a] hover:bg-[#F9F6F2] w-[42px] h-[42px] rounded-[8px]"
              onClick={onClickLarge}
            >
              <Icon component={bigSvg} />
            </div>
          ) : null}
          {size === SizeType.extraLarge && onClickSmall ? (
            <div
              className="absolute cursor-pointer flex items-center justify-center ltr:right-[12px] rtl:left-[12px] top-[8px] text-[20px] text-[#00000072] hover:text-[#160a0a] hover:bg-[#F9F6F2] w-[42px] h-[42px] rounded-[8px] cursor-pointer"
              onClick={onClickSmall}
            >
              <Icon component={smallSvg} />
            </div>
          ) : null}
        </>
      )}
    </Modal>
  );
}
